import PropTypes from 'prop-types'
import { useFilters } from '../../contexts/FilterContext'

function FilterAttribute({ attribute, groupId }) {
  const { getFilterValue, setFilter } = useFilters()
  const currentValue = getFilterValue(groupId, attribute.id)

  const handleChange = checked => {
    if (attribute.type === 'boolean') {
      // For boolean filters, filter for "Yes" when checked, null when unchecked
      setFilter(groupId, attribute.id, checked ? 'Yes' : null)
    } else if (attribute.type === 'level') {
      // For level filters, filter for specific facility level value
      setFilter(groupId, attribute.id, checked ? attribute.value : null)
    } else {
      setFilter(groupId, attribute.id, checked ? attribute.id : null)
    }
  }

  if (attribute.type === 'boolean') {
    return (
      <label className="flex items-center">
        <input
          type="checkbox"
          checked={currentValue === 'Yes'}
          onChange={e => handleChange(e.target.checked)}
          className="mr-2 text-primary-500 focus:ring-primary-500 focus:ring-offset-0"
        />
        <span className="text-sm text-gray-600">{attribute.name}</span>
      </label>
    )
  }

  if (attribute.type === 'level') {
    return (
      <label className="flex items-center">
        <input
          type="checkbox"
          checked={currentValue === attribute.value}
          onChange={e => handleChange(e.target.checked)}
          className="mr-2 text-primary-500 focus:ring-primary-500 focus:ring-offset-0"
        />
        <span className="text-sm text-gray-600">{attribute.name}</span>
      </label>
    )
  }

  // For other types (select, multiselect), implement as needed
  return (
    <label className="flex items-center">
      <input
        type="checkbox"
        checked={!!currentValue}
        onChange={e => handleChange(e.target.checked)}
        className="mr-2 text-primary-500 focus:ring-primary-500 focus:ring-offset-0"
      />
      <span className="text-sm text-gray-600">{attribute.name}</span>
    </label>
  )
}

FilterAttribute.propTypes = {
  attribute: PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  }).isRequired,
  groupId: PropTypes.string.isRequired,
}

export default FilterAttribute
